import React from "react";

type UlendoWordmarkProps = {
  className?: string;
  iconOnly?: boolean;
  size?: number;
};

const forest = "var(--ulendo-forest)";
const forestDark = "var(--ulendo-forest-dark)";
const gold = "var(--ulendo-gold)";

const UlendoGlyph: React.FC<{ size: number }> = ({ size }) => (
  <svg
    role="img"
    aria-label="Ulendo emblem"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className="shrink-0"
  >
    <defs>
      <linearGradient id="ulendo-circle" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor={forest} />
        <stop offset="100%" stopColor={forestDark} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" fill="url(#ulendo-circle)" />
    <path
      d="M24 18c5 18 16 18 16 28"
      fill="none"
      stroke="#fdfcf7"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="5 6"
    />
    <path
      d="M48 16 60 28 40 32z"
      fill={gold}
      transform="rotate(18 50 24)"
    />
  </svg>
);

export default function UlendoWordmark({ className, iconOnly = false, size = 40 }: UlendoWordmarkProps) {
  if (iconOnly) {
    return <UlendoGlyph size={size} />;
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ""}`}>
      <span
        className="font-semibold tracking-tight"
        style={{
          color: forest,
          fontFamily: "'Manrope', 'Inter', system-ui, -apple-system, sans-serif",
          fontSize: size * 0.72,
          lineHeight: 1,
        }}
      >
        Ulen
        <span style={{ letterSpacing: "-0.02em" }}>d</span>
      </span>
      <UlendoGlyph size={size} />
    </span>
  );
}
